export default __webpack_public_path__ + "static/media/cost.5c455f06.svg";